import z from 'zod';

export const TOPICS_IMPORT_MAX_FILE_SIZE = 5 * 1024 * 1024;

export const topicsImportFileSchema = z
  .file({ error: 'Selecione um arquivo .zip' })
  .refine(file => file.name.toLowerCase().endsWith('.zip'), {
    error: 'Apenas arquivos .zip são aceitos',
  })
  .refine(file => file.size > 0, { error: 'O arquivo está vazio' })
  .refine(file => file.size <= TOPICS_IMPORT_MAX_FILE_SIZE, {
    error: 'O arquivo deve ter no máximo 5 MB',
  });
